import type { RequestHandler } from "msw";
import { catalogHandlers as catalogHandlersRaw } from "@erp/mock-fixtures/handlers/catalog";

import { sessionHandlers } from "./session";

// The mock workspace is pinned to TypeScript 5.7 while the app resolves 5.9,
// so pnpm instantiates MSW's nominal RequestHandler class twice. The exported
// handlers are the same MSW 2.15 runtime values; normalize that package seam.
const catalogHandlers = catalogHandlersRaw as unknown as RequestHandler[];

export const handlers = [...sessionHandlers, ...catalogHandlers];
